// extracted by mini-css-extract-plugin
module.exports = {"list":"SectionBlock_list__1dT1L","header":"SectionBlock_header__lErxF","folderList":"SectionBlock_folderList__LStB1"};